export default class Message {

  static ERROR_NETWORK = '通信エラーが発生しました。';
  static NOT_HIT_FACILITY = '指定された範囲内に対象の施設がありませんでした。<br>最寄りの施設を表示します。';
}
